import React from "react";
import { Dropdown, MenuItem } from "react-bootstrap";
import CustomToggle from "../../../../Themes/DropDown/CustomToggle";

import Pagination from "../../../HSGPagination/HSGPagination";
import EpisodeCard from "./EpisodeCard";

import "../SmartClinic.css";
import NewEpisodes from "../../../../../src/NewEpisodes/";

const episodeSort = [
  { img: "A-Z", span: "Episode Date" },
  { img: "Z-A", span: "Episode Date" },
  // { img: 'A-Z', span: 'Criticality' },
  // { img: 'Z-A', span: 'Criticality' }
];

const episodeSortMeta = {
  1: { sortOrder: "desc", sortField: "modified_time" },
  2: { sortOrder: "asc", sortField: "modified_time" },
  3: { sortOrder: "desc", sortField: "modified_time" },
  4: { sortOrder: "desc", sortField: "modified_time" },
  default: { sortOrder: "desc", sortField: "modified_time" },
};

class EpisodeList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      inSearchString: "",

      defaultLimit: 5,
      defaultOffset: 0,
      defaultSortField: "modified_time",
      defaultSortBy: "desc",
      defaultSearchString: "",
    };
  }

  componentWillMount() {
    this.props.fetchEpisodeSearch(
      this.props.buildEpisodeHeader(
        {
          inOrganizationId: this.props.organizationId,
          inStudentId: this.props.studentId,
        },
        this.props.episodeHeader,
      ),
    );
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  showNext = (where) => {
    let { inLimit, inOffset } = this.props.episodeHeader;
    let { episodeTotal, episodeHeader } = this.props;
    if (where === "prev") {
      let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit;
      this.props.fetchEpisodeSearch(
        this.props.buildEpisodeHeader({ inOffset: newOffset }, episodeHeader),
      );
    } else {
      if (inOffset >= episodeTotal || inOffset + inLimit >= episodeTotal) {
        return;
      }
      let newOffset = inOffset + inLimit;
      this.props.fetchEpisodeSearch(
        this.props.buildEpisodeHeader({ inOffset: newOffset }, episodeHeader),
      );
    }
  };

  _renderPagination = (className) => {
    const { episodeHeader, episodeList, episodeTotal } = this.props;
    return episodeList && episodeList.length ? (
      <Pagination
        inOffset={episodeHeader.inOffset}
        showNext={this.showNext}
        data={episodeList}
        total={episodeTotal}
        className={className}
      />
    ) : null;
  };

  search(param) {
    let inSearchString = param;
    this.props.fetchEpisodeSearch(
      this.props.buildEpisodeHeader(
        {
          inSearchString: inSearchString,
          inLimit: this.state.defaultLimit,
          inOffset: this.state.defaultOffset,
        },
        this.props.episodeHeader,
      ),
    );
  }

  searchEpisode = (e) => {
    const { inSearchString } = this.state;
    e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase());
  };

  updateSearchBox = (e) => {
    e.target.value !== this.state.inSearchString &&
      this.setState({ inSearchString: e.target.value });
  };

  onSelectMenuItem = (e) => {
    let sortBy, sortField;

    if (e === null || e === undefined || parseInt(e) > 4) {
      e = "default";
    }
    sortBy = episodeSortMeta[e].sortOrder;
    sortField = episodeSortMeta[e].sortField;

    this.props.fetchEpisodeSearch(
      this.props.buildEpisodeHeader(
        {
          inSortField: sortField,
          inSortBy: sortBy,
          inLimit: this.state.defaultLimit,
          inOffset: this.state.defaultOffset,
        },
        this.props.episodeHeader,
      ),
    );
  };

  _renderSortOptions = () => (
    <Dropdown id="dropdown-custom-menu-episode-sort" className="sort-dropdown">
      <CustomToggle bsRole="toggle" className="sort-label">
        <span
          aria-hidden="true"
          data-icon="&#e900;"
          className="icon-sort"
        ></span>
        <span>Sort</span>
      </CustomToggle>

      <Dropdown.Menu bsRole="menu" className="select-sort">
        {episodeSort.map((m, i) => {
          return (
            <MenuItem
              key={i.toString()}
              eventKey={i + 1}
              onSelect={this.onSelectMenuItem}
            >
              <span className="sort-item-img">{m.img}</span>
              <span className="sort-item">{m.span}</span>
            </MenuItem>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );

  // _renderSearchBar = () => (
  //     <div className='search-box-container'>
  //         <input onChange={(e) => {this.updateSearchBox(e)}}
  //             onKeyDown={e=>{this.searchEpisode(e)}}
  //             placeholder="Type in Student Name , Admission Number or HSG-ID.."
  //             className="input-search-box"
  //             type='text'
  //             value={this.state.inSearchString}
  //             style={{marginLeft: 0}}
  //         />
  //     </div>
  // )

  // _renderToolbar = () => {
  //     return (
  //         <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style = {{padding:0}}>
  //                 {this.props.enableSearch && <div className="col-xs-11 col-sm-11 col-md-11 col-lg-11 left" style = {{padding:0}}>{this._renderSearchBar()}</div>}
  //                 {this.props.enableSort && <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 right" style = {{padding:0, textAlign: "right"}}>{this._renderSortOptions()}</div>}
  //         </div>
  //     )
  // }

  render() {
    let { episodeList, baseClass } = this.props;

    return (
      <div className={baseClass} style={{ marginTop: 20 }}>
        {/*                 
                <div className="col-md-12 col-sm-12 col-xs-12">
                    {this._renderToolbar()}
                </div> */}

        <div className="" style={{ marginTop: 20 }}>
          {episodeList && episodeList.length
            ? episodeList.map((episode, index) => (
                <EpisodeCard
                  episode={episode}
                  index={index}
                  key={index}
                  basicInfo={this.props.basicInfo}
                  parentInfo={this.props.parentInfo}
                  episodeInfo={this.props.episodeInfo}
                  headingLeft={this.props.headingLeft}
                  headingRight={this.props.headingRight}
                  enableEpisodeIdInBody={this.props.enableEpisodeIdInBody}
                  enableEpisodeIdLabelBody={this.props.enableEpisodeIdLabelBody}
                  enableSearch={this.props.enableSearch}
                  enableSort={this.props.enableSort}
                  dim={this.props.dim}
                  openStudentProfile={(studentId) =>
                    this.props.openStudentProfile(studentId)
                  }
                />
              ))
            : this.props.noDataAvailable("Episodes are not available!")}
        </div>
        {/* 
                <div className="" style ={{marginTop: 20}}>
                    {
                        episodeList && episodeList.length ? episodeList.map((episode, index) => (
                            <NewEpisodes
                            episode={episode}
                            index={index}
                            key={index}
                            buildEpisodeHeader={(newHeader, oldHeader) => this.props.buildEpisodeHeader(newHeader, oldHeader)}
                            fetchEpisodeSearch={(header) => this.props.fetchEpisodeSearch(header)}
                            openStudentProfile={(studentId) => this.props.openStudentProfile(studentId)}
                        />
                        
                        )) : this.props.noDataAvailable('Episodes are not available!')
                    }
                </div>
           */}

        <div className="col-md-12 col-sm-12 col-xs-12 padding-10">
          {this._renderPagination("hsg-dashboard-pagination-bottom right")}
        </div>
      </div>
    );
  }
}

export default EpisodeList;
